import { T } from '../../../../common/locale/translate';

export const virtualAirports = {
  ALL_GER: {
    country: 'VirtualAirports',
    iata: 'ALL_GER',
    name: T('germany'),
    unicodeName: 'VirtualAirports'
  },
  ALL_POL: {
    country: 'VirtualAirports',
    iata: 'ALL_POL',
    name: T('poland'),
    unicodeName: 'VirtualAirports'
  }
};

export const virtualOperators = {
  Niemcy: {
    code: 'ALL_GER',
    country: T('germany'),
    name: T('germany')
  }
};

export const offersListTabsIds = {
  SEO_OFFERS_LIST: 'seo_offers_list',
  SEO_REGION_INFORMATION: 'seo_region_information',
  SEO_PRACTICAL_INFORMATION: 'seo_practical_information',
  SEO_MAP: 'seo_map'
};

export const seoRegionsTabsNumbers = {
  [offersListTabsIds.SEO_OFFERS_LIST]: 0,
  [offersListTabsIds.SEO_REGION_INFORMATION]: 1,
  [offersListTabsIds.SEO_PRACTICAL_INFORMATION]: 2,
  [offersListTabsIds.SEO_MAP]: 3
};

export const tabParameterNameToTabNumber = {
  offers_list: seoRegionsTabsNumbers[offersListTabsIds.SEO_OFFERS_LIST],
  region_information:
    seoRegionsTabsNumbers[offersListTabsIds.SEO_REGION_INFORMATION],
  practical_information:
    seoRegionsTabsNumbers[offersListTabsIds.SEO_PRACTICAL_INFORMATION],
  map: seoRegionsTabsNumbers[offersListTabsIds.SEO_MAP]
};

export const offerTabsNames = {
  DATES: 'dates_with_prices',
  DESCRIPTION: 'description',
  MAP: 'map',
  FACILITIES: 'facilities',
  GALLERY: 'gallery',
  REVIEWS: 'reviews',
  ADDITIONAL_INFORMATION: 'additional_information',
  WEATHER: 'weather'
};

export const offerTabNamesToTabIds = {
  [offerTabsNames.DATES]: 0,
  [offerTabsNames.DESCRIPTION]: 1,
  [offerTabsNames.MAP]: 2,
  [offerTabsNames.FACILITIES]: 3,
  [offerTabsNames.GALLERY]: 4,
  [offerTabsNames.REVIEWS]: 5,
  [offerTabsNames.ADDITIONAL_INFORMATION]: 6,
  [offerTabsNames.WEATHER]: 7
};



// WEBPACK FOOTER //
// ./app/javascript/common/objects/consts.js